import React from 'react';
const ExperienceContext = React.createContext({
    locale: '',
    basePath: '',
    getJwt: () => Promise.resolve(''),
    roles: [],
    cardId: '',
    tenantId: '',
    userFirstName: '',
    setLoadingState: () => { },
    configuration: {},
    theme: null,
    setExitPrompt: () => { },
    hasApplyKey: false,
    setApplyKey: () => { }
});
export default ExperienceContext;